export default function genererCritereRecherche() {
  return {
    auto: '',
    datesDebut: {
      dateDebut: null,
      dateFin: null,
    },
    datesFin: {
      dateDebut: null,
      dateFin: null,
    },
    libelle: '',
    libelleInterne: '',
    marqueIds: [],
    tagIds: [],
    actif: true,
    newsLetter: null,
  };
}
